export type CriteriaType =
    | "env:all"
    | "env:none"
    | "env:local"
    | "env:staging"
    | "env:production"
    | "env:preview"
    | "env:green"
    | "env:blue"
    | "env:yellow"
    | "env:orange"
    | "env:purple"
    | "env:red"
    | "env:test"
    | "env:nonProduction"
    | "env:nonProductionData"
    | "env:nonStaging";

export interface CriteriaObject {
    id: CriteriaType;
    check(): boolean;
}

// for testability
export const getColorEnv = () => process.env.NEXT_PUBLIC_COLOR_ENV;

const criteriaList: CriteriaObject[] = [
    {
        id: "env:all",
        check: () => {
            return true;
        },
    },
    {
        id: "env:none",
        check: () => {
            return false;
        },
    },
    {
        id: "env:local",
        check: () => {
            return getColorEnv() === "development";
        },
    },
    {
        id: "env:staging",
        check: () => {
            return ["development", "staging"].includes(getColorEnv() as string);
        },
    },
    {
        id: "env:production",
        check: () => {
            return getColorEnv() === "production";
        },
    },
    {
        id: "env:green",
        check: () => {
            return getColorEnv() === "green";
        },
    },
    {
        id: "env:blue",
        check: () => {
            return getColorEnv() === "blue";
        },
    },
    {
        id: "env:yellow",
        check: () => {
            return getColorEnv() === "yellow";
        },
    },
    {
        id: "env:orange",
        check: () => {
            return getColorEnv() === "orange";
        },
    },
    {
        id: "env:purple",
        check: () => {
            return getColorEnv() === "purple";
        },
    },
    {
        id: "env:red",
        check: () => {
            return getColorEnv() === "red";
        },
    },
    {
        id: "env:preview",
        check: () => {
            return getColorEnv() === "preview";
        },
    },
    {
        id: "env:test",
        check: () => {
            return getColorEnv() === "test";
        },
    },
    {
        id: "env:nonProduction",
        check: () => {
            return getColorEnv() !== "production";
        },
    },
    {
        id: "env:nonProductionData",
        check: () => {
            return !["production", "preview", "blue", "orange"].includes(
                getColorEnv() as string
            );
        },
    },
    {
        id: "env:nonStaging",
        check: () => {
            return (
                getColorEnv() !== "production" &&
                getColorEnv() !== "orange" &&
                getColorEnv() !== "preview"
            );
        },
    },
];

export default criteriaList;
